import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import moment from "moment";
// import html2pdf from "html2pdf.js";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import * as XLSX from "xlsx";

const ReceivingReceipt = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [receive, setReceive] = useState([]);

  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);

  const [selectedId, setSelectedId] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;
  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue?.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet
  const downloadPdf = () => {
    setCurrentPage(1);
    const pdf = new jsPDF();
    responseData.forEach((item) => {
      // Generate barcode for the current item
      const barcodeRef = barcodeRefs.current[item.ReceivingId];
      const barcodeValue = `${item.ReceivingId}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        // barcode options
      });

      // Add barcode to PDF
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
    });
    pdf.deletePage(responseData.length + 1); // Remove extra page added by addPage() method
    pdf.save("barcodes.pdf");
  };

  //Function for print
  // const handlePrint = async () => {
  //   setCurrentPage(1);
  //   const pages = document.querySelectorAll("#print");
  //   const pdf = new jsPDF();

  //   const input = pages[0];
  //   const width = input.offsetWidth;
  //   const height = input.offsetHeight;

  //   const imgData = await html2canvas(input, { width, height }).then((canvas) =>
  //     canvas.toDataURL("image/png")
  //   );

  //   pdf.addImage(
  //     imgData,
  //     "JPEG",
  //     0,
  //     0,
  //     pdf.internal.pageSize.width,
  //     pdf.internal.pageSize.height
  //   );

  //   for (let i = 1; i < pages.length; i++) {
  //     const input = pages[i];
  //     const width = input.offsetWidth;
  //     const height = input.offsetHeight;

  //     const imgData = await html2canvas(input, { width, height }).then(
  //       (canvas) => canvas.toDataURL("image/png")
  //     );

  //     pdf.addPage();
  //     pdf.addImage(
  //       imgData,
  //       "JPEG",
  //       0,
  //       0,
  //       pdf.internal.pageSize.width,
  //       pdf.internal.pageSize.height
  //     );
  //   }

  //   // Convert the PDF to a Blob object
  //   const pdfBlob = pdf.output("blob");

  //   // Create a URL for the Blob object
  //   const pdfUrl = URL.createObjectURL(pdfBlob);

  //   // Open a new window with the URL
  //   const printWindow = window.open(pdfUrl);

  //   // Wait for the window to load and then print the PDF
  //   printWindow.addEventListener("load", () => {
  //     printWindow.print();
  //   });
  // };

  const handleUnSuspend = (pID) => {
    // console.log("Pid",pID);
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/listofsuspendrecordByid?id=${pID}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res from Suspended Receiving======>", res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //Function for lookup receipt

  const paramObject = useParams();

  const getData = () => {
    return axios.get(
      `${config.receivingBaseUrl}/receivings/lookupreceipt?receivingid=${paramObject.id}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      }
    );
  };

  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    setLoading(true);
    fetchedData();
    // axios
    //   .get(
    //     `${config.receivingBaseUrl}/receivings/lookupreceipt?receivingid=${paramObject.id}`,
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         "Access-Control-Allow-Origin": "*",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     console.log("res564565131", res);
    //     const ItemList = res.data.ResponseData.itemList;
    //     const SupplierData = res.data.ResponseData.supplierData;
    //     const unSuspendData = res.data.ResponseData.unSuspendData;
    //     console.log("ItemList", ItemList);
    //     console.log("SupplierData", SupplierData);

    //     console.log(res.data.ResponseData);
    //     if (res.data.ResponseCode === "SUCCESS") {
    //       setResponseData(ItemList);
    //       setSupplierData(SupplierData);
    //       setReceive(unSuspendData);
    //       console.log("11", responseData);
    //       //   barcodeRefs.current = responseData;
    //     }
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     setLoading(false);
    //   });
  }, [paramObject.id]);

  const fetchedData = async () => {
    try {
      const res = await getData();
      const ItemList = res.data.ResponseData.ReceivingItems;
      const SupplierData = res.data.ResponseData.SupplierDetails;
      const unSuspendData = res.data.ResponseData.ReceivingDetails;
      const companyData = res.data.ResponseData.CompanyDetails;

      console.log("ItemList", ItemList);
      console.log("SupplierData", SupplierData);
      console.log("companyDataissss", companyData[0].CompanyLogo);

      console.log("ressssssss 289", res.data.ResponseData);
      if (res.data.ResponseCode === "SUCCESS") {
        setResponseData(ItemList);
        setSupplierData(SupplierData);
        setReceive(unSuspendData);
        setCompanyData(companyData);
        console.log("11", responseData);
        //   barcodeRefs.current = responseData;
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  console.log("Receive issss", receive);

  //Function for export excel
  const handleExcelExport = () => {
    // console.log("Response Data is comingggg", responseData);
    // setLoading(true);
    // axios
    //   .post(
    //     `${config.receivingBaseUrl}/receivings/excelexport`,
    //     {
    //       receivingid: paramObject.id,
    //     },
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     console.log(res);
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     toastError(ERROR_MESSAGE);
    //     setLoading(false);
    //   });

    const data = responseData.length > 0 ? responseData : [];

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `customers_details_.xlsx`);
  };

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, item) => {
      console.log("item", item);
      const itemTotal = Number(item.Total);
      console.log("itemTotal>>>>>", itemTotal);
      if (typeof itemTotal === "number" && !isNaN(itemTotal)) {
        return itemTotal;
      } else {
        return total;
      }
    }, 0);
    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const totalPages = Math.ceil(responseData?.length / ITEMS_PER_PAGE);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  console.log("receive 371", receive);

  // Pdf Print
  const handlePrint = () => {
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `7px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    // Add the footer
    let footerElement = document.querySelector("#footer");
    let clonedFooter = footerElement.cloneNode(true);
    clonedFooter.style.fontSize = `7px`;
    clonedFooter.style.width = "560px";
    clonedFooter.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 10;
    let carryOverSum = 0;

    console.log("page-no 396", document.getElementById("page-no").innerText);

    for (var i = 1; i <= Math.ceil(responseData.length / 10); i++) {
      // Printing page no-
      let pageNoElement = clonedHeader.querySelector("#page-no");
      pageNoElement.innerText = i;

      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Condition based Css-
      if (i > 1) {
        content +=
          '<div style="width: 580px "><p style="font-weight: bold; font-size: 7px; text-align: right;">Carry Over: ' +
          carryOverSum.toFixed(2) +
          "<p></div>";
      }
      if (i == 1) {
        clonedHeader.style.marginTop = "2.7rem";
        clonedFooter.style.marginTop = "5.8rem";
      }
      if (i > 1 && i != Math.ceil(responseData.length / 10)) {
        clonedFooter.style.marginTop = "3.3rem";
      }

      // Checking remaining Loops printing last footer-
      if (i == Math.ceil(responseData.length / 10)) {
        let remainItems = Number(responseData?.length) % 10;
        let remainLoop = 10 - remainItems;

        clonedFooter.style.marginTop = `${remainLoop * 2}rem`;
      }

      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">S.No</th>' +
        '<th style="padding: 8px; width: 300px">Description</th>' +
        // '<th style="padding: 8px;">Barcode</th>' +
        '<th style="padding: 8px;">Price</th>' +
        '<th style="padding: 8px;">Quantity</th>' +
        '<th style="padding: 8px;">Discount%</th>' +
        '<th style="padding: 8px;">Total</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= responseData.length) {
          content +=
            "<tr>" +
            // First row
            "<tr>" +
            '<td style="font-size: 7px; padding: 2px 8px 0px 8px;">' +
            index +
            "</td>" +
            '<td colspan="6" style="font-size: 7px; padding: 0px 8px; z-index: 1; width: 560px">' +
            '<p style="font-size: 7px; font-weight: bold; margin: 0">' +
            responseData[index - 1].ItemVariationName +
            "</p>" +
            "<span>" +
            responseData[index - 1].Itemnumber +
            "</span>" +
            "</td>" +
            "</tr>" +
            // Second row
            "<tr>" +
            // '<td style="font-size: 7px; padding: 2px 8px;"></td>' +
            '<td style="font-size: 7px; padding: 2px 8px;"></td>' +
            '<td style="font-size: 7px; padding: 2px 8px;">Barcode</td>' +
            '<td style="font-size: 7px; padding: 2px 8px;">' +
            Number(responseData[index - 1].ItemCostPrice).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 2px 8px;">' +
            Number(responseData[index - 1].QuantityReceived).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 2px 8px;">' +
            Number(responseData[index - 1].DiscountPercent).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 2px 8px;">' +
            Number(responseData[index - 1].Total).toFixed(2) +
            "</td>" +
            "</tr>" +
            "</tr>"; // Closing extra tr tag from your previous code

          // Add the "Total" value to the carryOverSum on each page
          carryOverSum += Number(responseData[index - 1].Total);
        }

        if (index % 10 === 0) {
          startIndex = startIndex + 10;
          endIndex = endIndex + 10;
          break;
        }
      }

      // Printing Total or Carry Sum condition based-
      if (i !== Math.ceil(responseData.length / 10)) {
        content +=
          '<tr><td colspan="7" style="text-align: right; padding-right: 10px; font-weight: bold;">Carry Over: ' +
          carryOverSum.toFixed(2) +
          "</td></tr>";
      } else {
        content +=
          '<tr><td colspan="7" style="text-align: right; padding-top: 1.5rem; padding-right: 10px; padding-bottom: 0.5rem; font-weight: bold;">Sub Total: $' +
          Number(receive[0]?.Subtotal).toFixed(2) +
          "</td></tr>";

        content +=
          '<tr><td colspan="7" style="text-align: right; padding-right: 14px; padding-bottom: 0.5rem; font-weight: bold;">Discount: $' +
          Number(receive[0]?.DiscountEntireSale).toFixed(2) +
          "</td></tr>";

        content +=
          '<tr><td colspan="7" style="text-align: right; padding-right: 10px; padding-bottom: 0.5rem; font-weight: bold;">Total: $' +
          Number(receive[0]?.Total).toFixed(2) +
          "</td></tr>";
      }

      content += "</tbody>";
      content += "</table>";

      // Printing footer-
      content += " " + clonedFooter.outerHTML;
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
      },
    });
  };

  // Pdf Downaload-
  const handleDownload = () => {
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `7px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    // Add the footer
    let footerElement = document.querySelector("#footer");
    let clonedFooter = footerElement.cloneNode(true);
    clonedFooter.style.fontSize = `7px`;
    clonedFooter.style.width = "560px";
    clonedFooter.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 10;
    let carryOverSum = 0;

    console.log("page-no 396", document.getElementById("page-no").innerText);

    for (var i = 1; i <= Math.ceil(responseData.length / 10); i++) {
      // Printing page no-
      let pageNoElement = clonedHeader.querySelector("#page-no");
      pageNoElement.innerText = i;

      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Condition based Css-
      if (i > 1) {
        content +=
          '<div style="width: 580px "><p style="font-weight: bold; font-size: 7px; text-align: right;">Carry Over: ' +
          carryOverSum.toFixed(2) +
          "<p></div>";
      }
      if (i == 1) {
        clonedHeader.style.marginTop = "2.7rem";
        clonedFooter.style.marginTop = "5.8rem";
      }
      if (i > 1 && i != Math.ceil(responseData.length / 10)) {
        clonedFooter.style.marginTop = "3.3rem";
      }

      // Checking remaining Loops printing last footer-
      if (i == Math.ceil(responseData.length / 10)) {
        let remainItems = Number(responseData?.length) % 10;
        let remainLoop = 10 - remainItems;

        clonedFooter.style.marginTop = `${remainLoop * 2}rem`;
      }

      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">S.No</th>' +
        '<th style="padding: 8px; width: 300px">Description</th>' +
        // '<th style="padding: 8px;">Barcode</th>' +
        '<th style="padding: 8px;">Price</th>' +
        '<th style="padding: 8px;">Quantity</th>' +
        '<th style="padding: 8px;">Discount%</th>' +
        '<th style="padding: 8px;">Total</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= responseData.length) {
          content +=
            "<tr>" +
            // First row
            "<tr>" +
            '<td style="font-size: 7px; padding: 2px 8px 0px 8px;">' +
            index +
            "</td>" +
            '<td colspan="6" style="font-size: 7px; padding: 0px 8px; z-index: 1; width: 560px">' +
            '<p style="font-size: 7px; font-weight: bold; margin: 0">' +
            responseData[index - 1].ItemVariationName +
            "</p>" +
            "<span>" +
            responseData[index - 1].Itemnumber +
            "</span>" +
            "</td>" +
            "</tr>" +
            // Second row
            "<tr>" +
            // '<td style="font-size: 7px; padding: 2px 8px;"></td>' +
            '<td style="font-size: 7px; padding: 2px 8px;"></td>' +
            '<td style="font-size: 7px; padding: 2px 8px;">Barcode</td>' +
            '<td style="font-size: 7px; padding: 2px 8px;">' +
            Number(responseData[index - 1].ItemCostPrice).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 2px 8px;">' +
            Number(responseData[index - 1].QuantityReceived).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 2px 8px;">' +
            Number(responseData[index - 1].DiscountPercent).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 2px 8px;">' +
            Number(responseData[index - 1].Total).toFixed(2) +
            "</td>" +
            "</tr>" +
            "</tr>"; // Closing extra tr tag from your previous code

          // Add the "Total" value to the carryOverSum on each page
          carryOverSum += Number(responseData[index - 1].Total);
        }

        if (index % 10 === 0) {
          startIndex = startIndex + 10;
          endIndex = endIndex + 10;
          break;
        }
      }

      // Printing Total or Carry Sum condition based-
      if (i !== Math.ceil(responseData.length / 10)) {
        content +=
          '<tr><td colspan="7" style="text-align: right; padding-right: 10px; font-weight: bold;">Carry Over: ' +
          carryOverSum.toFixed(2) +
          "</td></tr>";
      } else {
        content +=
          '<tr><td colspan="7" style="text-align: right; padding-top: 1.5rem; padding-right: 10px; padding-bottom: 0.5rem; font-weight: bold;">Sub Total: $' +
          Number(receive[0]?.Subtotal).toFixed(2) +
          "</td></tr>";

        content +=
          '<tr><td colspan="7" style="text-align: right; padding-right: 14px; padding-bottom: 0.5rem; font-weight: bold;">Discount: $' +
          Number(receive[0]?.DiscountEntireSale).toFixed(2) +
          "</td></tr>";

        content +=
          '<tr><td colspan="7" style="text-align: right; padding-right: 10px; padding-bottom: 0.5rem; font-weight: bold;">Total: $' +
          Number(receive[0]?.Total).toFixed(2) +
          "</td></tr>";
      }

      content += "</tbody>";
      content += "</table>";

      // Printing footer-
      content += " " + clonedFooter.outerHTML;
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("receiving.pdf");
      },
    });
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header"
           style={
            {
              position: "fixed",
              top: "2px",
              zIndex: "999"
            }
          }
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Receivings Receipt</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/receiving">Receiving List</Link>
                </li>
                <li className="breadcrumb-item active">Receivings Receipt</li>
              </ul>
            </div>
          </div>
          <Link
            className="btn btn-sm btn-primary me-1 mb-5"
            to={`/manage-receiving/${responseData[0]?.ReceivingId}`}
            // onClick={handleUnSuspend(responseData[0]?.ReceivingId)}
          >
            Edit
          </Link>
          <Link
            className="btn btn-sm btn-primary me-1 mb-5"
            to={`/receiving-barcode-label/${responseData[0]?.ReceivingId}`}
          >
            Barcode Labels
          </Link>
          <Link className="btn btn-sm btn-primary me-1 mb-5" onClick={downloadPdf}>
            Barcode Sheet
          </Link>
          <Link
            className="btn btn-sm btn-primary me-1 mb-5"
            onClick={handleExcelExport}
          >
            Excel Export
          </Link>
          <Link
            className="btn btn-sm btn-primary me-1 mb-5"
            to={`/manage-receiving`}
            // onClick={handleUnSuspend(responseData[0]?.ReceivingId)}
            onClick={() =>
              localStorage.setItem("Clone", responseData[0]?.ReceivingId)
            }
          >
            Clone
          </Link>
          <Link className="btn btn-sm btn-primary me-1 mb-5" onClick={handlePrint}>
            Print
          </Link>
          <Link className="btn btn-sm btn-primary me-1 mb-5" onClick={handleDownload}>
            Download
          </Link>

          {/* Receiving Receipt */}
          <div id="print" className="form-control">
            <div className="card-body">
              {/* Header */}
              <div id="header">
                <div>
                  <div className="row">
                    <div className="col-md-4">
                      <p className="fw-bold">Receiving</p>
                      <span className="fw-bold">
                        {companyData[0]?.CompanyName}
                      </span>{" "}
                      <br />
                      <span>{companyData[0]?.CompanyAddress}</span> <br />
                      <span>{companyData[0]?.Website}</span> <br /> <br />
                      {supplierData?.map((item, index) => {
                        return (
                          <>
                            <span className="fw-bold">{item.Name}</span>
                            <br />
                            <span>{item.Companyname}</span>
                            <br />
                            <span>{item.Address}</span>
                            <br />
                            <span>{item.Country}</span>
                            <br />
                            <span>{item.Zip}</span>
                          </>
                        );
                      })}
                    </div>

                    <div className="col-md-4 ">
                      <h2 className="fw-bold">
                        {companyData[0]?.CompanyLogo !== undefined &&
                        companyData[0]?.CompanyLogo !== "" ? (
                          <img
                            src={companyData[0]?.CompanyLogo}
                            alt={companyData[0]?.CompanyName}
                          />
                        ) : (
                          <p className="fw-bold">Jarkan</p>
                        )}
                      </h2>

                      <div className="row">
                        <div className="col-md-12">
                          <p style={{ marginBottom: "5px" }}>
                            <strong>Shipping Address</strong>
                          </p>
                          {supplierData?.map((item, index) => {
                            return (
                              <p style={{ marginBottom: "5px" }}>
                                {item.Name} <br />
                                <span>{item.Address}</span>
                              </p>
                            );
                          })}
                          {/* <p>Same as Bill-to</p> */}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-4">
                          <p className="fw-bold" style={{ margin: 0 }}>
                            Original
                          </p>
                        </div>
                        <div className="col-md-8">
                          <p className="fw-bold" style={{ margin: 0 }}>
                            Order Confirmation
                          </p>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="row">
                              <div className="col-md-3">
                                <p style={{ margin: 0 }}>
                                  No:
                                  <br />
                                  {receive[0]?.BillNo > 0
                                    ? receive[0]?.BillNo + "- Receiving"
                                    : "-"}
                                </p>
                              </div>
                              <div className="col-md-5">
                                <p style={{ margin: 0 }}>
                                  Date:
                                  <br />
                                  {moment(receive[0]?.ReceivingDate).format(
                                    "DD-MM-YYYY"
                                  )}
                                </p>
                              </div>
                              <div className="col-md-4">
                                <label>Page No:</label>
                                <p style={{ margin: 0 }}>
                                  <label id="page-no">{currentPage}</label>/
                                  {totalPages}
                                </p>
                              </div>
                            </div>
                            {/* <hr /> */}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="row"
                              style={{
                                borderBottom: "1px solid",
                                paddingBottom: "0.5rem",
                                paddingTop: "0.5rem",
                              }}
                            >
                              {supplierData?.map((item, index) => {
                                // console.log("supplierId===>",{item.ID});
                                return (
                                  <>
                                    <div className="col-md-4">
                                      <p style={{ margin: "0" }}>
                                        <strong>Supplier No:</strong>
                                      </p>
                                      {item.ID}
                                    </div>
                                    <div className="col-md-8">
                                      <strong>
                                        Federal Tax ID - Business Partner
                                      </strong>
                                    </div>
                                    <div className="row">
                                      <div className="col-md-12">
                                        <p>
                                          {" "}
                                          <strong>Your Reference</strong>{" "}
                                        </p>
                                        {item.Internalnotes}
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                            {/* <hr /> */}
                            <div
                              className="row"
                              style={{
                                paddingBottom: "0.5rem",
                                paddingTop: "0.5rem",
                              }}
                            >
                              <div className="col-md-12">
                                {supplierData?.map((item, index) => {
                                  return (
                                    <>
                                      <p style={{ marginBottom: "5px" }}>
                                        <strong>Contact Number</strong>
                                      </p>
                                      <span className="">
                                        {item.PhoneNumber}
                                      </span>
                                    </>
                                  );
                                })}
                              </div>
                            </div>
                            {/* <hr /> */}
                            <div
                              className="row"
                              style={{
                                paddingTop: "0.5rem",
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="d-flex justify-content-between">
                  <p style={{ fontWeight: "bold" }}>
                    Receive Date :{" "}
                    {moment(receive[0]?.ReceivingDate).format("DD-MM-YYYY")}
                  </p>
                  <p style={{ fontWeight: "bold" }}>Currency : $</p>
                </div>
              </div>

              {/* Body */}
              <div className="table-responsive" id="body">
                <table className="table mt-1">
                  <thead>
                    <tr>
                      <th className="col-md">S.No</th>
                      <th className="col-md-3">Description</th>
                      {/* <th className="col-md-2" style={{ textAlign: "center" }}>
                        Barcode
                      </th> */}
                      <th className="col-md-2" style={{ textAlign: "right" }}>
                        Price
                      </th>
                      <th className="col-md-2" style={{ textAlign: "right" }}>
                        Quantity
                      </th>
                      <th className="col-md-2" style={{ textAlign: "right" }}>
                        Discount %
                      </th>
                      {/* <th className="col-md-2" style={{ textAlign: "right" }}>
                        Tax %
                      </th> */}
                      <th className="col-md-2" style={{ textAlign: "right" }}>
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseData?.map((item, index) => {
                      console.log("responseDataaff", responseData);
                      const individualTotal =
                        parseFloat(item.QuantityReceived) *
                        parseFloat(item.ItemCostPrice);

                      return (
                        <>
                          <tr>
                            <td className="col-md">{++index}</td>
                            {/* <td style={{ textAlign: "left", borderBottom:"0px", padding: "5px" "10px"; }} colSpan={6}> */}
                            {/* <td className="col-md-2" */}

                            {/* > */}
                            {/* <strong>{item.Items}</strong> */}
                            {/* <small className="d-flex justify-content-start align-items-center">
                              <span className="mr-2">Item Number:</span>
                              <span className="flex-fill text-center fw-bold">
                                {item.ItemNumber}
                              </span>
                            </small> */}
                            {/* </td> */}
                            <td
                              style={{ textAlign: "left" }}
                              className="col-md-2"
                            >
                              {/* {++index}
                            &nbsp; &nbsp; &nbsp;
                            <strong>{item.Items}</strong>
                            */}
                              <small className="col-md-2">
                                {/* <strong>Item Name:</strong> */}
                                <strong>{item?.ItemName}:</strong>
                                <strong>{item.ItemVariationName}</strong>
                              </small>
                              <p>
                                Item Number:
                                {item.Itemnumber}
                              </p>
                            </td>
                            {/* <td className="col-md-2">{item.Items} </td> */}
                            <td
                              className="col-md-2"
                              style={{ textAlign: "right" }}
                            >
                              {Number(item.ItemCostPrice).toFixed(2)}
                            </td>
                            <td
                              className="col-md-2"
                              style={{ textAlign: "right" }}
                            >
                              {Number(item.QuantityReceived).toFixed(2)}
                            </td>
                            <td
                              className="col-md-2"
                              style={{ textAlign: "right" }}
                            >
                              {Number(item.DiscountPercent).toFixed(2)}
                            </td>
                            {/* <td
                              className="col-md-2"
                              style={{ textAlign: "right" }}
                            >

                              {Number(item.Tax).toFixed(2)}
                            </td> */}
                            <td
                              className="col-md-2"
                              style={{ textAlign: "right" }}
                            >
                              {Number(item.Total).toFixed(2)}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>

                <div style={{ textAlign: "right" }} className="mt-3">
                  <p style={{ margin: "0" }}>
                    <strong>Sub Total: </strong>$
                    {Number(receive[0]?.Subtotal).toFixed(2)}
                  </p>
                  <p style={{ margin: "0" }}>
                    <strong>Discount : </strong>$
                    {Number(receive[0]?.DiscountEntireSale).toFixed(2)}
                  </p>
                  <p style={{ margin: "0" }}>
                    <strong>Total Amount: </strong>$
                    {Number(receive[0]?.Total).toFixed(2)}
                  </p>
                </div>
                <hr />
              </div>

              {/* Footer */}
              <div className="row" id="footer">
                <div className="col-md-4">
                  <span>CEO:</span>
                  <br />
                  <span>Shareholder:</span>
                  <br />
                  <span>Tax Official</span>
                  <br />
                  <span>Headquarters:</span>
                  <br />
                  <span>Website:</span>
                  <br />
                </div>
                <div className="col-md-4">
                  <span>Phone:</span>
                  <br />
                  <span>Fax:</span>
                  <br />
                  <span>E-Mail:</span>
                  <br />
                  <span>Tax No.:</span>
                  <br />
                  <span>Tax ID No.:</span>
                  <br />
                </div>
                <div className="col-md-4">
                  <span>Bank Name:</span>
                  <br />
                  <span>Bank Account:</span>
                  <br />
                  <span>Routing Code:</span>
                  <br />
                  <span>Swift/BIC Code:</span>
                  <br />
                  <span>IBAN:</span>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "none" }}>
        {responseData?.map((item) => (
          <>
            <div key={item.ReceivingId}>
              <canvas
                data-name={item.ReceivingId}
                ref={(el) => (barcodeRefs.current[item.ReceivingId] = el)}
                id={`barcode-${item.ReceivingId}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default ReceivingReceipt;
